(function() {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('StoreManagementDetailController', StoreManagementDetailController)
        .directive('onErrorSrc', function () {
            return {
                link: function (scope, element, attrs) {
                    element.bind('error', function () {
                        if (attrs.src != attrs.onErrorSrc) {
                            attrs.$set('src', attrs.onErrorSrc);
                        }
                    });
                }
            }
        });

    StoreManagementDetailController.$inject = ['$scope', '$rootScope', '$localStorage', 'FlyersService', '$state',
        '$timeout', 'uiGridConstants', 'uiGridBuilder', '$translate', '$stateParams', 'StoreService', '$uibModal', '$q',
        'CategoryService', 'UserService', 'UserProfileService', 'toastr', 'RemoveModalFactory', 'TeamService', 'ModalFactory', 'storeManagementConstants', 'MODAL_CONTENT_TYPES'];

    function StoreManagementDetailController($scope, $rootScope, $localStorage, FlyersService, $state,
        $timeout, uiGridConstants, uiGridBuilder, $translate, $stateParams, StoreService, $uibModal, $q,
        CategoryService, UserService, UserProfileService, toastr, RemoveModalFactory, TeamService, ModalFactory, storeManagementConstants, MODAL_CONTENT_TYPES) {
        var vm = this;

        vm.usersTable = false;
        vm.profilesTable = false;
        vm.salesPointListItems = [];
        vm.selectedSalesPointId = null;

        vm.tabType = "Users";
        vm.isLoading = true;
        vm.showTable = false;
        vm.defaultSearchIndex = 0;
        vm.tableDivisor = 5;
        vm.columnDefs = getColumnDefsUsers();
        vm.filterFields = {};
        vm.authorities = $localStorage.profileAuthorities;
        vm.showIcon = null;
        loadAll();
        init();

        function init() {
            checkAuthorities();
        }

        function loadAll() {
            StoreService.getStore($stateParams.id).then(function(response) {
                vm.store = response.data;
                vm.store.image = getImage();
                vm.imagePath = "/admin/api/" + vm.store.id + "/store";
                getCategoryName();
                loadNumberOfFlyers();
                buildSalesPointListItems();
                vm.gridTableOptions = getGridOptions();
                vm.usersTable = true;
                vm.isLoading = false;

                if ($stateParams.fromStep) {
                    vm.getEditStorePage(true)
                }
            });
        }

        function checkAuthorities() {
                if (vm.authorities) {
                    vm.enabledEditUser = vm.authorities.some(function(authority) {
                        return authority ===  storeManagementConstants.AUTHORITIES.ADMIN_UPDATE_USER || authority ===  storeManagementConstants.AUTHORITIES.STORE_UPDATE_USER || authority === storeManagementConstants.AUTHORITIES.STORE_CREATE_USER
                            || authority === storeManagementConstants.AUTHORITIES.ADMIN_CREATE_USER;
                    });
                    vm.showIcon = vm.enabledEditUser ?  storeManagementConstants.ROLE_ICON.EDIT : storeManagementConstants.ROLE_ICON.SHOW;
                }
        }

        function buildSalesPointListItems() {
            vm.salesPointListItems = [];
            if (!vm.store || !vm.store.points) {
                return;
            }
            vm.store.points.forEach(function(point) {
                vm.salesPointListItems.push({
                    value: point.id,
                    label: point.name || '',
                    subtitle: vm.addressFormat(point),
                    point: point
                });
            });
        }

        vm.addressFormat = function(point) {
            if (!point) {
                return $translate.instant("communication.no-information");
            }
            var address = point.address;
            var addressNumber = point.number;
            var district = point.neighborhood;
            var city = point.city;
            var state = point.state;
            var zipcode = point.postalCode || point.zipCode;

            if (!zipcode && !address && !state && !city && !addressNumber) {
                return $translate.instant("communication.no-information");
            }

            var formatted = (
                (address ? address + (addressNumber ? ", " : " ") : "") +
                (addressNumber ? addressNumber + (district ? ", " : (city ? " - " : " ")) : "") +
                (district ? district + (city ? ", " : " ") : "") +
                (city ? city + (state ? " - " : " ") : "") +
                (state ? state + (zipcode ? ", " : " ") : "") +
                (zipcode ? zipcode : "")
            );
            return formatted;
        };

        vm.salesPointActions = [
            {
                icon: 'fa fa-pencil',
                label: 'store-management.salespoint.actions.edit',
                method: function(item) {
                    vm.editSalesPoint(item);
                }
            },
            {
                icon: 'fa fa-trash',
                label: 'store-management.salespoint.actions.remove',
                method: function(item) {
                    vm.openRemoveConfirmation(item);
                }
            }
        ];

        vm.editSalesPoint = function(item) {
            var point = item && item.point ? item.point : item;
            if (!point){
                return
            }
            var salesPoint = {
                id: point.id,
                pointlocation: angular.copy(point),
                latitude: point.coordinate ? point.coordinate.latitude : 0,
                longitude: point.coordinate ? point.coordinate.longitude : 0
            };
            $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function() {
                        return {
                            title: $translate.instant('store-management.salespoint.title'),
                            cancelButtonText: $translate.instant('global.messages.remove.cancel'),
                            confirmButtonText: $translate.instant('store-management.salespoint.subtitle'),
                            store: vm.store,
                            salesPoint: salesPoint,
                            type: MODAL_CONTENT_TYPES.SALES_POINT
                        };
                    }
                }
            });
        };

        vm.openRemoveConfirmation = function(item) {
            var point = item && item.point ? item.point : item;
            if (!point) {
                return;
            }
            if (vm.store.points.length <= 1) {
                toastr.error($translate.instant('store-management.messages.remove.minSalesPoints'));
                return;
            }
            var removeSalesPoint = function() {
                StoreService.deleteSalesPoint(point.id).then(function() {
                    var idx = vm.store.points.findIndex(function(p) {
                        return p.id === point.id;
                    });
                    if (idx >= 0) {
                        vm.store.points.splice(idx, 1);
                    }
                    buildSalesPointListItems();
                    toastr.success($translate.instant('store-management.messages.salespoint.remove.success'));
                }, function() {
                    toastr.error($translate.instant('store-management.messages.salespoint.remove.error'));
                });
            };
            ModalFactory.openWarningModal(
                null,
                $translate.instant('store-management.detail.removeSalesPoint.message'),
                $translate.instant('store-management.detail.removeSalesPoint.smallText'),
                null,
                $translate.instant('store-management.detail.removeSalesPoint.confirmButton'),
                $translate.instant('store-management.detail.removeSalesPoint.cancelButton'),
                removeSalesPoint
            );
        };

        vm.reloadUsers = function() {
            $scope.search();
        }

        $scope.search = function() {
            if (vm.tabType === "Users") {
                vm.changeTableToUsers();
            } else if (vm.tabType === "Profiles") {
                vm.changeTableToProfile();
            } else if (vm.tabType === "Teams") {
                vm.changeTableToTeam();
            }
        }

        $scope.$on('salesPointUpdated', function(event, salesPoint) {
            updateSalesPoint(salesPoint);

        });

        $scope.$on('salesPointCreated', function(event, salesPoint) {
            createSalesPoint(salesPoint);
        });



        $scope.$on('userUpdated', function(event, data) {
            $scope.search();
        });

        vm.loadStoreImage = function(image) {
          var random = new Date().getTime();
          return (image + '?r=' + random);
        }

        vm.addSalesPoint = function() {
            $uibModal.open({
                templateUrl: 'app/components/modal/side-modal/side-modal.html',
                controller: 'SideModalController',
                windowClass: 'side-modal',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    content: function() {
                        return {
                            title: $translate.instant('store-management.detail.salespoint'),
                            cancelButtonText: $translate.instant('global.messages.remove.cancel'),
                            confirmButtonText: $translate.instant('store-management.salespoint.subtitle'),
                            store: vm.store,
                            salesPoint: undefined,
                            type: MODAL_CONTENT_TYPES.SALES_POINT
                        };
                    }
                }
            });
        }

        function findAndReplaceUpdatedSalePoint(sp) {
            var id = (sp.pointlocation && sp.pointlocation.id) || sp.id;
            var idx = vm.store.points.findIndex(function(p) { return p.id === id; });
            var updatedPoint = angular.copy(sp.pointlocation);
            updatedPoint.coordinate = {
                latitude: sp.latitude || 0,
                longitude: sp.longitude || 0
            };
            if (idx >= 0) {
                vm.store.points[idx] = updatedPoint;
            } else {
                vm.store.points.push(updatedPoint);
            }
        }

        function prepareSalesPointForApi(point) {
            var newPoint = point.pointlocation;
            newPoint.storeId = vm.store.id;
            newPoint.number = newPoint.number === "" ? storeManagementConstants.SALES_POINT_ADDRESS.WITHOUT_NUMBER : newPoint.number;
            newPoint.neighborhood = newPoint.neighborhood === "" ? storeManagementConstants.SALES_POINT_ADDRESS.WITHOUT_NEIGHBORHOOD : newPoint.neighborhood;
            newPoint.coordinate = {
                latitude: point.latitude || 0,
                longitude: point.longitude || 0
            };
            return newPoint;
        }

        function createSalesPoint(point) {
            var newPoint = prepareSalesPointForApi(point);
            StoreService.createSalesPoint(newPoint).then(function(data) {
                newPoint.id = data.id;
                newPoint.coordinate = {
                    latitude: point.latitude || 0,
                    longitude: point.longitude || 0
                };
                vm.store.points.push(newPoint);
                buildSalesPointListItems();
                toastr.success($translate.instant('store-management.messages.salespoint.create.success'));
            }, function() {
                toastr.error($translate.instant('store-management.messages.salespoint.create.error'));
            });
        }

        function updateSalesPoint(point) {
            var newPoint = prepareSalesPointForApi(point);
            StoreService.updateSalesPoint(newPoint).then(function() {
                findAndReplaceUpdatedSalePoint(point);
                buildSalesPointListItems();
                toastr.success($translate.instant('store-management.messages.salespoint.update.success'));
            }, function() {
                toastr.error($translate.instant('store-management.messages.salespoint.update.error'));
            });
        }

        function updateStore() {
            StoreService.updateStore(vm.store).then(function() {
                toastr.success($translate.instant('store-management.messages.update.success'));
            }, function() {
                toastr.error($translate.instant('store-management.messages.update.error'));
            });
        }

        $rootScope.$on('$translateChangeSuccess', function() {
            getCategoryName();
        });

        function getCategoryName() {
            if (vm.store && vm.store.categoryKey ) {
                CategoryService.getCategoryTitleByKey(vm.store.categoryKey, $translate.use()).then(function(response) {
                    vm.store.categoryName = response.data;
                });
            }
        }

        function loadNumberOfFlyers() {
            FlyersService.getNumberOfFlyers(vm.store.id, $translate.use()).then(function(response) {
                vm.store.numberOfFlyers = response.data;
            });
        }

        function getColumnDefsUsers() {
            var testCellTemplate = '';
            return [{
                    field: 'login',
                    displayName: 'userManagement.login',
                    headerCellFilter: 'translate',
                    filtered: false
                },
                {
                    field: 'firstName',
                    displayName: 'userManagement.firstName',
                    headerCellFilter: 'translate',
                    filtered: false
                },
                {
                    field: 'lastName',
                    displayName: 'userManagement.lastName',
                    headerCellFilter: 'translate',
                    filtered: false
                },
                {
                    field: 'email',
                    displayName: 'userManagement.email',
                    headerCellFilter: 'translate',
                    width: '25%',
                    filtered: false
                },
                {
                    field: 'profileName',
                    displayName: 'userManagement.profileName',
                    headerCellFilter: 'translate',
                    cellTemplate: '<span ng-repeat=\"profile in row.entity.userProfiles\" class=\"label label-info\">{{ profile.profileName }}</span>'
                }
            ];
        }

        function getColumnDefsProfiles() {
            return [{
                field: 'name',
                displayName: 'showcaseApp.profile.name',
                headerCellFilter: 'translate'
            }];
        }

        function getColumnDefsTeams() {
            return [{
                field: 'name',
                displayName: 'showcaseApp.team.name',
                headerCellFilter: 'translate'
            }];
        }
        function getGridOptions() {
            return uiGridBuilder.withDefaultOptions()
                .withActionColumn(100)
                .addActionToActionColumn(
                    $translate.instant('store-management.tooltip.edit'),
                    "vm.getEditPage",
                    vm.showIcon,
                    "text-primary",
                    true,
                    "row.entity.disabledAction"
                )
                .addActionToActionColumn(
                    $translate.instant('store-management.tooltip.delete'),
                    "vm.getDeletePage",
                    "icon-ksc-trash-regular",
                    "text-primary",
                    vm.enabledEditUser,
                    "row.entity.disabledAction"
                )
                .withColumns(vm.columnDefs).build('search');
        }

        function refreshDataInfos() {
            vm.gridTableApi = vm.gridTableOptions.getApiGridTable();
            vm.startRegistry = (vm.gridTableApi.pagination.getPage() * vm.gridTableOptions.paginationPageSize) - vm.gridTableOptions.paginationPageSize;
            vm.endCalc = vm.gridTableOptions.paginationPageSize * vm.gridTableApi.pagination.getPage();
            vm.endRegistry = vm.endCalc > vm.totalItems ? vm.totalItems : vm.endCalc;
        }

        vm.addTeamStore = function() {
            $uibModal.open({
                templateUrl: 'app/admin/team-management/team-management-dialog.html',
                controller: 'TeamManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    team: function() {
                        return undefined;
                    },
                    storeId: function() {
                        return vm.store.id;
                    }
                }
            });
        }

        vm.addUserStore = function() {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/user-management-dialog.html',
                controller: 'UserManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    user: function() {
                        return undefined;
                    },
                    storeId: function() {
                        return vm.store.id;
                    },
                    store: function() {
                        return angular.copy(vm.store);
                    },
                    enabledEditUser: vm.enabledEditUser
                }
            });
        }

        vm.getEditPage = function(row) {
            if (vm.tabType === "Users") {
                vm.getEditPageUsers(row);
            } else if (vm.tabType === "Profiles") {
                vm.getEditPageProfiles(row);
            } else if (vm.tabType === "Teams") {
                vm.getEditPageTeam(row);
            }
        }

        vm.getDeletePage = function(row) {
            if (vm.tabType === "Users") {
                vm.getDeletePageUsers(row);
            } else if (vm.tabType === "Profiles") {
                vm.getDeletePageProfiles(row);
            } else if (vm.tabType === "Teams") {
                vm.getDeletePageTeam(row);
            }
        }

        vm.isDeleteActionEnabled = function(row) {
            if (vm.tabType === "Teams") {
                return row.type !== 'DEFAULT'
            } else {
                return true;
            }
        }

        vm.getEditPageUsers = function(row) {
            $uibModal.open({
                templateUrl: 'app/admin/user-management/user-management-dialog.html',
                controller: 'UserManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    storeId: function(){
                        return vm.store.id;
                    },
                    store: function() {
                        return angular.copy(vm.store);
                    },
                    user: function(UserService) {
                        return UserService.getUser({login:row.login, storeId: vm.store.id});
                    },
                    enabledEditUser: vm.enabledEditUser
                }
            });
        }

        vm.getEditPageTeam = function(row) {
            $uibModal.open({
                templateUrl: 'app/admin/team-management/team-management-dialog.html',
                controller: 'TeamManagementDialogController',
                controllerAs: 'vm',
                scope: $scope,
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    storeId: function(){
                        return vm.store.id;
                    },
                    team: function() {
                        return row;
                    }
                }
            });
        }

        vm.getDeletePageTeam = function(team) {
            var remove = function() {
                TeamService.remove(team.id).then(function () {
                    toastr.success($translate.instant('team-management.deleted'));
                    $scope.$emit('userUpdated');
                });
            };
            ModalFactory.openWarningModal($translate.instant('team-management.delete-modal.title'),
                        $translate.instant('team-management.delete-modal.subtitle', { team: team.name }),
                        $translate.instant('team-management.delete-modal.small-text'),
                        null,
                        $translate.instant('team-management.delete-modal.confirm-button'),
                        $translate.instant('team-management.delete-modal.cancel-button'),
                        remove
                    );
        }

        vm.getDeletePageUsers = function(user) {
            var remove = function() {
                UserService.deleteUser({login: user.login, storeId: vm.store.id}).then(function (data) {
                    toastr.success($translate.instant('userManagement.deleted'));
                    $scope.$emit('userUpdated', data);
                });
            };
            ModalFactory.openWarningModal($translate.instant('userManagement.delete-modal.title'),
                        $translate.instant('userManagement.delete-modal.subtitle', { login: user.login }),
                        $translate.instant('userManagement.delete-modal.small-text'),
                        null,
                        $translate.instant('userManagement.delete-modal.confirm-button'),
                        $translate.instant('userManagement.delete-modal.cancel-button'),
                        remove
                    );
        }

        vm.getEditPageProfiles = function(row) {
            if(!row.disabledAction){
                $state.go('store-profile-detail', {
                    storeId: vm.store.id,
                    id: row.id
                });
            }
        }

        vm.getDeletePageProfiles = function(profile) {
            if(!profile.disabledAction){
                var remove = function() {
                    UserProfileService.deleteProfile(profile.id, vm.store.id).then(function(data) {
                        toastr.success($translate.instant('showcaseApp.profile.messages.remove.success'));
                        $scope.$emit('userUpdated', data);
                    }, function() {
                        toastr.error($translate.instant('showcaseApp.profile.messages.remove.error'));
                    });
                };
                ModalFactory.openWarningModal($translate.instant('showcaseApp.profile.delete-modal.title'),
                            $translate.instant('showcaseApp.profile.delete-modal.subtitle', { name: profile.name }),
                            $translate.instant('showcaseApp.profile.delete-modal.small-text'),
                            null,
                            $translate.instant('showcaseApp.profile.delete-modal.confirm-button'),
                            $translate.instant('showcaseApp.profile.delete-modal.cancel-button'),
                            remove
                        );
            }
        }

        function getImage() {
            return vm.store.logo ? vm.store.logo.replace('%25s', 'logo') :  storeManagementConstants.FILE.DEFAULT_IMAGE_STORE;
        }

        vm.getEditStorePage = function(isStep) {
            $uibModal.open({
                templateUrl: 'app/admin/store-management/store-management-edit.html',
                controller: 'StoreManagementEditController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'mobile-fullscreen-modal',
                resolve: {
                    store: function() {
                        return angular.copy(vm.store);
                    },
                    isStep: isStep
                }
            }).result.then(function(data) {
                if (data) {
                    vm.store = data;
                    $timeout(function() {
                        vm.store.image = getImage();
                    }, 2000);
                    loadNumberOfFlyers();
                }
            });
        }

        vm.getEditStoreImagePage = function() {

            $uibModal.open({
                templateUrl: 'app/admin/store-management/store-management-edit-image.html',
                controller: 'StoreManagementEditImageController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    store: function() {
                        return angular.copy(vm.store);
                    }
                }
            }).result.then(function(data) {
                vm.store.image = null;
                if (data) {
                    vm.store = data;
                    toastr.success($translate.instant('store-management.messages.update.success'));
                    $timeout(function() {
                        vm.store.image = vm.loadStoreImage(vm.store.storeLogo);
                    }, 4000);
                    loadNumberOfFlyers();
                }
            });
        }

        vm.changeTab = function(type) {
            if (type === "Users") {
                vm.columnDefs = getColumnDefsUsers();
                vm.usersTable = true;
                vm.profilesTable = false;
                vm.teamsTable = false;
            } else if (type === "Profiles") {
                vm.columnDefs = getColumnDefsProfiles();
                vm.usersTable = false;
                vm.profilesTable = true;
                vm.teamsTable = false;
            } else if (type === "Teams") {
                vm.columnDefs = getColumnDefsTeams();
                vm.usersTable = false;
                vm.profilesTable = false;
                vm.teamsTable = true;
            }
            vm.tabType = type;
            vm.gridTableOptions = getGridOptions();
        }

        vm.changeTableToProfile = function() {
            var params = null;
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            pageable.size = pageable.size + 1;
            UserProfileService.listProfiles(pageable, $localStorage.defaultStore.storeId, vm.filterFields).then(function(response) {
                response.data = angular.forEach(response.data, function(value) {
                    return value.disabledAction = vm.tabType === "Profiles" ? (value.profileOwner === null && $localStorage.defaultStore.storeId !== 0 ? true: false) : false
                });
                vm.totalItems = response.headers['x-total-count'];
                vm.gridTableOptions.virtualizationThreshold = response.data.length;
                vm.gridTableOptions.update(response.data, vm.totalItems);
                vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                refreshDataInfos();
            });
        }

        vm.changeTableToTeam = function() {
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            var params = {
                name: vm.filterFields && vm.filterFields.name && vm.filterFields.name.length > 0 ? vm.filterFields.name : null,
                storeId: $localStorage.defaultStore.storeId,
                isEnabled: true,
                size: pageable.size + 1,
                page: pageable.page
            }

            TeamService.list(params, pageable).then(function(response) {
                if (response.data) {
                    vm.totalItems = response.data.totalElements;
                    vm.gridTableOptions.virtualizationThreshold = response.data.totalElements;
                    vm.gridTableOptions.update(response.data.content, vm.totalItems);
                    vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                    refreshDataInfos();
                }
            });
        }

        vm.changePageSize = function(pageSize) {
            vm.gridTableOptions.paginationPageSize = pageSize;
            $scope.search();
        };


        vm.changeTableToUsers = function() {
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            pageable.size = pageable.size + 1;
            UserService.listUsersByStoreId(pageable, vm.store.id, vm.filterFields).then(function(response) {
                vm.totalItems = response.headers['x-total-count'];
                vm.gridTableOptions.virtualizationThreshold = response.data.length;
                vm.gridTableOptions.update(response.data, vm.totalItems);
                vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                refreshDataInfos();
            });
        }

        vm.changeTableToTeams = function() {
            var pageable = vm.gridTableOptions.getPageAndSortOptions().getPageAbleObj();
            var params = {
                name: vm.filterFields && vm.filterFields.name && vm.filterFields.name.length > 0 ? vm.filterFields.name : null,
                storeId: $localStorage.defaultStore.storeId,
                isEnabled: true,
                size: pageable.size + 1,
                page: pageable.page
            }
            TeamService.list(params, pageable).then(function(response) {
                if (response.data) {
                    vm.totalItems = response.data.totalElements;
                    vm.gridTableOptions.virtualizationThreshold = response.data.totalElements;
                    vm.gridTableOptions.update(response.data.content, vm.totalItems);
                    vm.pagesSize = createArray(vm.totalItems, vm.tableDivisor);
                    refreshDataInfos();
                }
            });
        }

        function createArray(range, divisor) {
            if (!divisor) divisor = 0;
            if (divisor != 0) {
                range = range / divisor;
            }
            var values = [];
            var iteratorNumber = 0;
            for (var i = 0; i < range; i++) {
                iteratorNumber = divisor != 0 ? i * divisor : i + 1;
                values.push(iteratorNumber);
            }
            return values;
        };

        vm.changeColumnView = function($index) {
            vm.gridTableOptions.columnDefs[$index].visible = !(vm.gridTableOptions.columnDefs[$index].visible || vm.gridTableOptions.columnDefs[$index].visible === undefined);
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        };

        vm.changeColumnFilter = function($index) {
            if (vm.gridTableOptions.columnDefs[$index].filtered) {
                vm.gridTableOptions.columnDefs[$index].filtered = false;
                vm.gridTableOptions.columnDefs[$index].headerCellClass = '';
            } else {
                vm.gridTableOptions.columnDefs[$index].filtered = true;
                vm.gridTableOptions.columnDefs[$index].headerCellClass = 'ui-grid-bgcolor';
            }
            vm.gridTableApi.core.notifyDataChange(uiGridConstants.dataChange.COLUMN);
        };

        vm.checkColumnFilter = function(attr, $index) {
            if (attr.length >= 1 && !vm.gridTableOptions.columnDefs[$index].filtered) {
                vm.changeColumnFilter($index);
            }
            if (attr.length <= 0 && vm.gridTableOptions.columnDefs[$index].filtered) {
                vm.changeColumnFilter($index);
            }
            vm.reloadUsers();
        };
    }
})();
